import { render, staticRenderFns } from "./DeviceParam.vue?vue&type=template&id=352e1a36&scoped=true&"
import script from "./DeviceParam.vue?vue&type=script&lang=js&"
export * from "./DeviceParam.vue?vue&type=script&lang=js&"
import style0 from "./DeviceParam.vue?vue&type=style&index=0&id=352e1a36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e1a36",
  null
  
)

export default component.exports